import { render, staticRenderFns } from "./TaskListWrapper.vue?vue&type=template&id=32c18962"
import script from "./TaskListWrapper.vue?vue&type=script&lang=ts"
export * from "./TaskListWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c18962')) {
      api.createRecord('32c18962', component.options)
    } else {
      api.reload('32c18962', component.options)
    }
    module.hot.accept("./TaskListWrapper.vue?vue&type=template&id=32c18962", function () {
      api.rerender('32c18962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/TaskListWrapper.vue"
export default component.exports